import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import RichTextEditor from "../Course/Question/UI/RichTextEditor";
import { EXPRESS_BASE_URL } from "../../../../../Helpers/apiConfig";

// mainpage tablosundaki sütun adları
const EDITOR_ID_BY_FIELD = {
    kvkk: "kvkkText",
    terms: "termsText",
    onbilgilendirme: "onbilgilendirmeText",
    satissozlesmesi: "satissozlesmesiText",
};

// /postmaintexts tek seferde 4 sütunu da güncelliyor; bu yüzden diğer 3 alanın
// son çekilen değerini de gövdeye ekleyip sadece bu sayfanın alanını değiştiriyoruz.
const AdminGeneralSettingsPage = ({ field, title }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [msg, setMsg] = useState("");
    const [defaultValue, setDefaultValue] = useState("");
    const currentValuesRef = useRef({ kvkk: "", terms: "", onbilgilendirme: "", satissozlesmesi: "" });

    const editorId = EDITOR_ID_BY_FIELD[field];

    const fetchData = async () => {
        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
            };
            const res = await axios({
                method: 'get',
                url: `${EXPRESS_BASE_URL}/getmaintexts`,
                headers: headerss
            });
            const row = (res.data && res.data[0]) || {};
            currentValuesRef.current = {
                kvkk: row.kvkk || "",
                terms: row.terms || "",
                onbilgilendirme: row.onbilgilendirme || "",
                satissozlesmesi: row.satissozlesmesi || "",
            };
            setDefaultValue(currentValuesRef.current[field]);
        } catch (err) {
            setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const editedHtml = document.getElementById(editorId).value;
        const payload = {
            ...currentValuesRef.current,
            [field]: editedHtml,
        };
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
            };
            const res = await axios({
                method: 'put',
                url: `${EXPRESS_BASE_URL}/postmaintexts`,
                data: payload,
                headers: headerss
            });
            if (res.status === 200) {
                currentValuesRef.current = payload;
                Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: `Tamam`,
                });
            } else {
                setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
            }
        } catch (err) {
            Swal.fire({
                title: "Hata",
                text: "Güncelleme başarısız oldu.",
                icon: "error",
                confirmButtonText: `Tamam`,
            });
        }
    };

    return (
        <div style={{ backgroundColor: "white", padding: "3%" }}>
            <div style={{ textAlign: "center" }}>
                <h1>{title}</h1>
            </div>
            {msg}
            {loading ? (
                <p>Yükleniyor...</p>
            ) : (
                <form onSubmit={handleSubmit}>
                    <RichTextEditor id={editorId} label={title} defaultValue={defaultValue} />
                    <div className='d-flex justify-content-center'>
                        <button type="submit" className="btn btn-primary btn-lg">{t("update")}</button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default AdminGeneralSettingsPage;
